import DefaultLayout from './layouts/defaultLayout';
import HomeView from './views/homeView';
import React from 'react';
import MeasuresView from './views/measuresView';
import { langData } from './locale';
import AlphabetView from './views/alphabetView';
import ModulesView from './views/modulesView';
import KeyOrgsView from './views/keyOrgsView';
import AboutView from './views/aboutView';
import logo1 from './assets/img/logo/logo-1.png';
import logo2 from './assets/img/logo/logo-2.jpeg';
import logo3 from './assets/img/logo/logo-3.png';
import logo4 from './assets/img/logo/logo-4.png';
import logo5 from './assets/img/logo/logo-5.png';
import logo6 from './assets/img/logo/logo-6.png';
import logo7 from './assets/img/logo/logo-7.jpeg';
import logo8 from './assets/img/logo/logo-8.png';
import logo9 from './assets/img/logo/rszne.png';
import partner1 from './assets/img/partner/AMZS LOGO CMYK-1.png';
import partner2 from './assets/img/partner/AmCham_Preferred_positive_RGB (2).png';
import partner3 from './assets/img/partner/A1_01_08RED_4_L_cmyk.jpg';
import partner4 from './assets/img/partner/color_logo_transparent.png';
import partner5 from './assets/img/partner/sgggg.svg';
import partner6 from './assets/img/partner/Knauf Insulation Logo.png';
import partner7 from './assets/img/partner/jsripskrs.png';
import partner8 from './assets/img/partner/RIKO_logotip_CMYK (1).png';
import partner9 from './assets/img/partner/MERKUR-vse-urejeno-RGB.jpg';
import partner10 from './assets/img/partner/umff.png';
import ContactView from './views/contactView';
import RightsView from './views/rightsView';
import TermsOfUse from './views/termsOfUse';
import ModuleView from './views/moduleView';
import EmployeesAndEmployers from './views/employeesAndEmployers';
import Quiz1 from './views/quiz1';
import Quiz2 from './views/quiz2';
import LeadersInOrg from './views/leadersInOrg';
import DefaultNoKazaloLayout from './layouts/nokazalolayout';

const appstate = {
	debug: false,
	currentLanguage: () => {
		return localStorage.getItem('language') || 'enUK';
	},
	currentLangData: () => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return langData[appstate.currentLanguage()];
	},
	routes: () => {
		return {
			home: {
				path: '/',
				element: (
					<DefaultLayout>
						<HomeView />
					</DefaultLayout>
				),
			},
			moreAboutProject: {
				path: '/about-the-project',
				element: (
					<DefaultLayout>
						<AboutView />
					</DefaultLayout>
				),
			},
			employeesAndEmployers: {
				path: '/employees-and-employers',
				element: (
					<DefaultLayout>
						<EmployeesAndEmployers />
					</DefaultLayout>
				),
			},
			quiz1: {
				path: '/quiz1',
				element: (
					<DefaultNoKazaloLayout>
						<Quiz1 />
					</DefaultNoKazaloLayout>
				),
			},
			quiz2: {
				path: '/quiz2',
				element: (
					<DefaultNoKazaloLayout>
						<Quiz2 />
					</DefaultNoKazaloLayout>
				),
			},
			leadersInOrg: {
				path: '/leaders-in-org',
				element: (
					<DefaultLayout>
						<LeadersInOrg />
					</DefaultLayout>
				),
			},
			measuresForWorkersAndEmployers: {
				path: '/measures-for-workers-and-employers',
				element: <DefaultLayout></DefaultLayout>,
			},
			educationalModules: {
				path: '/educational-modules',
				element: (
					<DefaultLayout>
						<ModulesView />
					</DefaultLayout>
				),
			},
			keyOrganizations: {
				path: '/key-organizations',
				element: (
					<DefaultLayout>
						<KeyOrgsView />
					</DefaultLayout>
				),
			},
			contact: {
				path: '/contact',
				element: (
					<DefaultLayout>
						<ContactView />
					</DefaultLayout>
				),
			},
			rights: {
				path: '/rights',
				element: (
					<DefaultLayout>
						<RightsView />
					</DefaultLayout>
				),
			},
			termsOfUse: {
				path: '/terms-of-use',
				element: (
					<DefaultLayout>
						<TermsOfUse />
					</DefaultLayout>
				),
			},
			module: {
				path: '/module/:id',
				element: (
					<DefaultLayout>
						<ModuleView />
					</DefaultLayout>
				),
			},
		};
	},
	partners: () => {
		return [
			partner2,
			partner4,
			partner9,
			partner8,
			partner10,
			partner6,
			partner7,
			partner3,
			partner5,
			partner1,
		];
	},
	orgs: () => {
		if (appstate.currentLanguage() === 'slSI') {
			return [
				{
					name: 'Zveza svobodnih sindikatov Slovenije ',
					description:
						'Zveza svobodnih sindikatov Slovenije (ZSSS) je prostovoljna in demokratična organizacija, ki združuje 23 sindikatov dejavnosti iz različnih sektorjev celotne Slovenije in člane ter članice tako iz zasebnega kot javnega sektorja. Zaradi reprezentativnosti ZSSS vpliva na vsebino kolektivnih pogodb in sodeluje v ekonomsko-socialnem svetu, kjer skupaj z delodajalci in vlado usklajuje predloge zakonov in drugih dokumentov. Svojemu članstvu ZSSS zagotavlja brezplačno pravno in drugo strokovno pomoč.\n' +
						'\n' +
						'V okviru ZSSS od leta 2001 deluje Odbor za enake možnosti, ki se zavzema, da je načelo integracije enakosti spolov upoštevano pri oblikovanju vseh politik in aktivnosti ZSSS. Od leta 2006 Odbor za enake možnosti podeljuje priznanje Roža mogota za dosežek leta na področju uveljavljanja enakih možnosti žensk in moških na trgu dela in v družbi.\n' +
						'\n' +
						'ZSSS redno izvaja terenske aktivnosti in kreira poročila, glede aktualnih razmer v družbi. Na svoji spletni strani objavlja izvlečke poročil, ki prispevajo k ozaveščanju o pomembnosti usklajevanja poklicnega in zasebnega življenja. Več o vsebinah je dostopno tukaj: ABCDEFGH' +
						'\n________________\nKontakt:\n' +
						'Telefon: +386 (0)1 4341 200\n' +
						'E-pošta: zsss@sindikat-zsss.si\n' +
						'Spletna stran: https://www.zsss.si',
					logo: logo1,
				},
				{
					name: 'Združenje Manager',
					description:
						'Združenje Manager povezuje več kot 1.200 slovenskih managerjev in managerk in že 30 let spodbuja razvoj managerskega poklica v Sloveniji. Z aktivnim sodelovanjem pri oblikovanju gospodarskega okolja v Sloveniji soustvarja rast konkurenčnosti slovenskega gospodarstva in tako sooblikuje slovenski družbeni prostor.\n' +
						'\n' +
						'Združenje Manager poseduje široko bazo znanja, ki se je podjetja lahko poslužujejo za izobraževanja o trajnostnem voditeljstvu, strokovnemu razvoju ženskega managementa, poslovni etiki in drugih tematikah.  V okviru letnega Managerskega kongresa, Združenje Manager podeli številčna priznanja slovenskim podjetjem in managerjem, med katerimi je tudi priznanje Vključi.Vse, ki se podeljuje z namenom izpostaviti podjetja s strategijo vključevanja in raznolikosti ter razvitim odnosom do enakosti spolov. S podelitvijo priznanja Vključi.Vse se Združenje zavzema za uravnotežena vodstva v podjetjih, saj imajo raznolika vodstva bolj odprto organizacijsko kulturo, bolje razumejo svoje stranke in dosegajo višje dobičke.' +
						'\n________________\nKontakt:\n' +
						'Telefon: +386 (0)1 5898 584\n' +
						'E-pošta: info@zdruzenje-manager.si\n' +
						'Spletna stran: https://www.zdruzenje-manager.si/sl/',
					logo: logo2,
				},
				{
					name: 'Ekvilib Inštitut',
					description:
						'Ekvilib Inštitut je neprofitna in neodvisna organizacija, ki deluje na področjih družbene odgovornosti, človekovih pravic in razvojnega sodelovanja. S svojim delom Inštitut prispeva k opolnomočenju vodij in zaposlenih v podjetjih z znanjem kako vsem akterjem v podjetju omogočiti enake možnosti in s tem prispevati k družbeno odgovornemu poslovanju ter posledično večji produktivnosti.\n' +
						'\n' +
						'Aktivnosti, ki jih Inštitut izvaja so primarno osredotočene na pomoč podjetjem pri razvoju organizacijske kulture, temelječe na enakosti spolov, družbeni odgovornosti in doslednem razvoju delovnih timov ter kompetenc. Inštitut nudi svetovanje in podporo podjetjem pri vključitvi v naslednje aktivnosti:\n' +
						'\n' +
						'- certifikat Družini prijazno podjetje,\n' +
						'- certifikat Družbeno odgovoren delodajalec,\n' +
						'- Mreža za družbeno odgovornost Slovenije,\n' +
						'- certifikat Trajnostno podjetje.\n' +
						'\n' +
						'Dodatno Ekvilib Inštitut organizira izkustveno aplikativne delavnice v okviru Akademije KRIDD za ključne vodje, perspektivne kadre, kadrovske delavce in neformalne vodje, ki temeljijo na iskanju inovativnih rešitev in idej.' +
						'\n________________\nKontakt:\n' +
						'Telefon: +386 (0)1 4303 751\n' +
						'E-pošta: info@ekvilib.org\n' +
						'Spletna stran: http://www.ekvilib.org/sl/',
					logo: logo4,
				},
				{
					name: 'Inštitut za proučevanje enakosti spolov',
					description:
						'Inštitut za proučevanje enakosti spolov (IPES) je nevladna, neprofitna in prostovoljska organizacija, ki si prizadeva za poglabljanje razumevanja enakosti spolov v družbi. Glavni namen delovanja IPES je ozaveščanje različnih segmentov javnosti o družbeni konstrukciji spolnih vlog in o pomenu vključevanja vseh spolov v izgradnjo skupnosti, ki temelji na načelu nediskriminacije in enakih možnostih.\n' +
						'\n' +
						'Leta 2018 se je pod okriljem IPES vzpostavil prvi slovenski družbeno odgovorni certifikat za podjetja in organizacije za področje enakosti spolov, ki celovito obravnava organizacijsko strukturo, kulturo in delovne procese posameznih družb – GEMA. Certifikat GEMA vsakemu imetniku (podjetju) omogoča individualizirano oceno obstoječega stanja, ki se na podlagi poglobljenih analiz prelevi v sklop po meri zastavljenih ukrepov. Ukrepi so razdeljeni v 10 sklopov, ki med drugim obsegajo tudi nepristransko zaposlovanje, nagrajevanje in napredovanje, usklajevanje poklicnega in zasebnega življenja, regulacijo plačne vrzeli med ženskami in moškimi, sistem mentorstva, učinkovite mehanizme za preprečevanje nadlegovanja in spolnega nadlegovanja na delovnem mestu ter krepitev vključujoče organizacijske kulture na vseh ravneh organizacije. Sinhrono in medsebojno vzajemno delovanje implementiranih ukrepov, podjetjem in organizacijam omogoča optimizacijo človeških virov, izboljšanje učinkovitosti delovnih procesov in predvsem dobro počutje zaposlenih na delovnem mestu.' +
						'\n________________\nKontakt:\n' +
						'E-pošta: info@ipes-si.org\n' +
						'\n' +
						'Spletna stran: https://ipes-si.org/#s1' +
						'\n' +
						'Spletna stran: https://gema-certificate.com/sl/domov/',
					logo: logo5,
				},
				{
					name: 'Listina raznolikosti Slovenija',
					description:
						'Zavod Listina raznolikosti Slovenije ponuja izobraževanja vsem, ki jih zanima strateško vodenje raznolikosti ter graditev harmoničnega in vključujočega delovnega okolja. Raznolikosti so zavezane sodobne poslovne strategije, ki s prepoznavanjem, komunikacijo in vključevanjem, razvijajo bolj inovativne in trajnostne rezultate.\n' +
						'\n' +
						'Zavod ponuja tudi pridobitev certifikata Workplace Inclusion Champion (W.I.C), ki omogoča razumevanje in ponuja orodja na področju enakega vključevanja oseb z invalidnostjo, skupnosti LGBTQ+ in žensk. V okviru izobraževanja se naslovi vzpostavitev programa vključujočega mentorstva in prevetritev obstoječih mentorskih programov z namenom izgradnje vključujoče organizacijske kulture.\n' +
						'\n' +
						'Listina raznolikosti Slovenije v svojem poslanstvu zbira dobre prakse upravljanja raznolikosti in jih promovira na različnih dogodkih ter v publikacijah. Vsako leto, ob mednarodnem dnevu človekovih pravic, organizira okroglo mizo, kjer slovenski podpisniki predstavijo svoje dobre prakse.' +
						'\n________________\nKontakt:\n' +
						'Telefon: +386 (0)30 661 449\n' +
						'E-pošta: listina@raznolikost.eu\n' +
						'Spletna stran: https://www.raznolikost.eu',
					logo: logo6,
				},
				{
					name: 'Great Place To Work®',
					description:
						'Great Place To Work® je mednarodno prisoten Inštitut, ki deluje v več kot 80 državah. Poslanstvo Inštituta je strokovno podprto merjenje zadovoljstva zaposlenih na delovnem mestu in posledično oblikovanje ukrepov za delodajalce, ki prispevajo k izgradnji trajnostne organizacijske kulture, temelječe na medsebojnem zaupanju, spodbujanju raznolikosti in samoiniciativnosti zaposlenih. \n' +
						'\n' +
						'Inštitut podeljuje enega najbolj znanih certifikatov Great Place To Work delodajalcem, ki ustvarjajo presežne izkušnje zaposlenih, v smislu izgradnje zaupanja in občutka vključenosti ter spodbujanja raznolikosti v vseh operacijah podjetja. Temelj pridobitve certifikata je zadostno število doseženih točk na strokovno podprtem vprašalniku Trust Index™ (indeks zaupanja), ki ga anonimno rešijo vsi zaposleni in delodajalci, dodatno pa certifikat predvideva implementacijo ukrepov, specifičnih za stanje organizacijske kulture v posameznih podjetjih. Zaposleni na Great Place To Work® delujejo tudi kot svetovalci delodajalcem in vodjem v podjetjih ter aktivno sodelujejo pri oblikovanju in implementaciji ukrepov, izobraževanju kadrov in ozaveščanju o pomembnosti posamezniku prijazne organizacijske kulture v podjetjih. Certifikat se obnavlja vsako leto. Podjetja, ki ne delujejo neposredno v državah, kjer je Inštitut prisoten (tudi Slovenija) lahko vseeno pridobijo certifikat.' +
						'\n________________\nKontakt:\n' +
						'Spletna stran: https://www.greatplacetowork.com',
					logo: logo7,
				},
			];
		} else {
			return [
				{
					name: 'The Association of Free Trade Unions of Slovenia',
					description:
						'The Association of Free Trade Unions of Slovenia (ZSSS) is a voluntary and democratic organization that brings together 23 trade unions from various sectors throughout Slovenia and members from both the private and public sectors. Due to its representativeness, the ZSSS influences the content of collective agreements and participates in the economic and social council, where together with employers and the government it coordinates proposals for laws and other documents. The ZSSS provides free legal and other professional assistance to its members.\n' +
						'Since 2001, the Committee for Equal Opportunities has been operating within the ZSSS, which advocates that the principle of gender equality is taken into account in the formulation of all policies and activities of the ZSSS. Since 2006, the Committee for Equal Opportunities has been awarding Roža Mogot for the achievement of the year in the field of equal opportunities for women and men in the labor market and in society.\n' +
						'ZSSS regularly conducts field activities and creates reports regarding the current situation in society. On its website, it publishes excerpts of reports that contribute to raising awareness of the importance of balancing professional and private life. More about the content is available here: https://www.zsss.si/podrocja-dela/enake-moznosti/enakost-spolov/ \n' +
						'Telefon: +386 (0)1 4341 200\n' +
						'E-pošta: zsss@sindicat-zsss.si\n' +
						'Spletna stran: https://www.zsss.si',
					logo: logo1,
				},
				{
					name: "Managers' Association of Slovenia",
					description:
						'The Manager Association connects more than 1,200 Slovenian managers and has been promoting the development of the managerial profession in Slovenia for 30 years. By actively participating in the creation of the economic environment in Slovenia, it co-creates the growth of the competitiveness of the Slovenian economy and thus co-shapes the Slovenian social space.\n' +
						"The Manager Association has a wide knowledge base that companies can use for training on sustainable leadership, professional development of women's management, business ethics and other topics. As part of the annual Manager's Congress, Združenje Manager awards numerous awards to Slovenian companies and managers, including the Vključi.Vse award, which is awarded with the aim of highlighting companies with a strategy of inclusion and diversity and a developed attitude towards gender equality. By awarding the Vkluži.Vse recognition, the Association advocates for balanced managements in companies, as diverse managements have a more open organizational culture, better understand their customers and achieve higher profits.\n" +
						'Telefon: +386 (0)1 5898 584\n' +
						'E-pošta: info@zdruzenje-manager.si\n' +
						'Spletna stran: https://www.zdruzenje-manager.si/sl/',
					logo: logo2,
				},
				{
					name: 'Ekvilib Institute',
					description:
						'Ekvilib Institute is a non-profit and an independent organization that works in the fields of social responsibility, human rights and development cooperation. Through its work, the Institute contributes to the empowerment of managers and employees in companies with the knowledge of how to provide equal opportunities to all actors in the company and thereby contribute to socially responsible business and consequently greater productivity.\n' +
						'The activities carried out by the Institute are primarily focused on helping companies develop an organizational culture based on gender equality, social responsibility and the consistent development of work teams and competencies. The institute offers advice and support to companies in engaging in the following activities:\n' +
						'- Family-friendly company certificate,\n' +
						'- Socially Responsible Employer certificate,\n' +
						'- Social Responsibility Network of Slovenia,\n' +
						'- Sustainable company certificate.\n' +
						'In addition, the Ekvilib Institute organizes experiential application workshops within the framework of the KRIDD Academy for key managers, perspective personnel, personnel workers and informal managers, which are based on the search for innovative solutions and ideas.\n' +
						'Telefon: +386 (0)1 4303 751\n' +
						'E-pošta: info@ekvilib.org\n' +
						'Spletna stran: http://www.ekvilib.org/sl/',
					logo: logo4,
				},
				{
					name: 'Inštitut za proučevanje enakosti spolov',
					description:
						'The Gender Equality Research Institute (IPES) is a non-governmental, non-profit and voluntary organization that works to deepen the understanding of gender equality in society. The main purpose of IPES is to raise awareness among different segments of the public about the social construction of gender roles and about the importance of including all genders in building a community based on the principle of non-discrimination and equal opportunities.\n' +
						'In 2018, under the auspices of IPES, the first Slovenian socially responsible certificate for companies and organizations in the field of gender equality was established, which comprehensively addresses the organizational structure, culture and work processes of individual companies - GEMA. The GEMA certificate enables each holder (company) to make an individualized assessment of the existing situation, which, based on in-depth analyses, is translated into a set of tailor-made measures. The measures are divided into 10 sections, which include, among other things, impartial recruitment, reward and promotion, reconciliation of professional and private life, regulation of the wage gap between women and men, a mentoring system, effective mechanisms for preventing harassment and sexual harassment in the workplace, and strengthening inclusive organizational culture at all levels of the organization. The synchronous and mutual interaction of the implemented measures enables companies and organizations to optimize human resources, improve the efficiency of work processes and, above all, the well-being of employees at work.\n' +
						'E-pošta: info@ipes-si.org\n' +
						'Spletna stran: https://ipes-si.org/#s1\n' +
						'Spletna stran: https://gema-certificate.com/sl/domov/',
					logo: logo5,
				},
				{
					name: 'Diversity Charter Slovenia',
					description:
						'Diversity Charter Slovenia offers training to anyone interested in the strategic management of diversity and building a harmonious and inclusive work environment. Modern business strategies are committed to diversity, which through recognition, communication and inclusion, develop more innovative and sustainable results.\n' +
						'The Institute also offers the Workplace Inclusion Champion (W.I.C) certification, which provides an understanding and offers tools in the field of equal inclusion of persons with disabilities, the LGBTQ+ community and women. In the context of education, Diversity Charter Slovenia addresses possible etablishments of inclusive mentoring programs and upgrades of existing mentoring programs with the aim of building an inclusive organizational culture.\n' +
						'In its mission, the Diversity Charter of Slovenia collects good diversity management practices and promotes them at various events and in publications. Every year, on International Human Rights Day, it organizes a round table where Slovenian signatories present their good practices.\n' +
						'Telefon: +386 (0)30 661 449\n' +
						'E-pošta: listina@raznolikost.eu\n' +
						'Spletna stran: https://www.raznolikost.eu',
					logo: logo6,
				},
				{
					name: 'Great Place To Work®',
					description:
						"Great Place To Work® is an internationally present Institute that operates in more than 80 countries. The Institute's mission is the professionally supported measurement of employee satisfaction at the workplace and, as a result, the creation of measures for employers that contribute to building a sustainable organizational culture based on mutual trust, promoting diversity and self-initiative of employees.\n" +
						'The institute awards one of the best-known Great Place To Work certifications to employers who create superior employee experiences, in terms of building trust and a sense of inclusion, and promoting diversity across all company operations. The basis for obtaining the certificate is a sufficient number of points achieved on the professionally supported Trust Index™ questionnaire, which is completed anonymously by all employees and employers, and the certificate additionally provides for the implementation of measures specific to the state of organizational culture in individual companies. Employees at Great Place To Work® also act as consultants to employers and managers in companies and actively participate in the design and implementation of measures, staff training and awareness of the importance of an individual-friendly organizational culture in companies. The certificate is renewed every year. Companies that do not operate directly in countries where the Institute is present (including Slovenia) can still obtain a certificate.' +
						'Spletna stran: https://www.greatplacetowork.com',
					logo: logo7,
				},
			];
		}
	},
};

export const getLocaledString = (
	stringSLSI: string,
	stringENUK: string,
): string => {
	if (appstate.currentLanguage() === 'enUK') {
		return stringENUK;
	}

	return stringSLSI;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window['appstate'] = appstate;

export default appstate;
